import UrlBuilder from 'APP/Helpers/UrlBuilder'
import Analytics from 'APP/Services/Analytics'
import { getColourScheme } from './AppearanceUtils'

export const handleNavigationContactInfo = (contactInfo, navigation) => {
  const { id, name, actionType, screenName, navigationUrl } = contactInfo || {}

  const isNavigation = actionType === 'navigation' && screenName && navigationUrl

  if (isNavigation) {
    navigation.navigate(screenName, { navigationUrl })
    return
  }

  const uri = UrlBuilder.cmsContactInfoUrl(id, getColourScheme())

  navigation.navigate('cmsScreen', { uri, showShareButton: false })
  Analytics.trackScreen(`contactInfoScreen : ${id} : ${name}`)
}
